import { DataTable } from 'primereact/datatable';
import React from 'react';
import { DT_PAGE_REPORT_TEMPLATE, DT_PAGINATOR_TEMPLATE, DT_ROWS_PER_PAGE_OPTIONS, DT_SHORT_ROWS_PER_PAGE_OPTIONS } from '@/Config/constants';

/**
 * A customizable datatable template which can be used for listing/searching/sorting/filtering items
 */
const DatatableTemplate = ({ 
    children, 
    items, 
    selectedItems, 
    setSelectedItems, 
    header, 
    loading,
    rowsPerPage, 
    totalRecords, 
    first, 
    emptyMessage, 
    onPageChange, 
    shortTable,
    paginator=true,
    customProps 
}) => {
    return (
        <div className="general-datatable">
            <DataTable value={items} paginator={paginator} lazy header={header} rows={rowsPerPage} removableSort dataKey="id" rowHover 
                loading={loading} loadingIcon="pi pi-sun"
                paginatorTemplate={DT_PAGINATOR_TEMPLATE} 
                rowsPerPageOptions={shortTable === true ? DT_SHORT_ROWS_PER_PAGE_OPTIONS : DT_ROWS_PER_PAGE_OPTIONS}
                selection={selectedItems} 
                onSelectionChange={e => setSelectedItems(e.value)}
                responsiveLayout="scroll"
                emptyMessage={emptyMessage}
                currentPageReportTemplate={DT_PAGE_REPORT_TEMPLATE}
                totalRecords={totalRecords}
                first={first}
                onPage={onPageChange}
                {...customProps}
            >
                {children}
            </DataTable>
        </div>
    );
};

export default DatatableTemplate;